module.exports = __webpack_public_path__ + "img/2-ebook-icon.2ffe25e4.svg";